import { render } from "./MessageDropdown.vue?vue&type=template&id=3b25d972"
import script from "./MessageDropdown.vue?vue&type=script&lang=js"
export * from "./MessageDropdown.vue?vue&type=script&lang=js"

import "./MessageDropdown.vue?vue&type=style&index=0&id=3b25d972&lang=scss"
script.render = render

export default script